import React from 'react';
import '../App.css';

function ProjectDescription(props) {
  const m = props.projectModel;
  return (
    <div className="project-description">
      <div className="subhead-white" style={{ textTransform: 'uppercase' }}>{m.client}</div>
      <div className="subhead-white" style={{ textTransform: 'none' }}>{m.projectName}</div>
      {m.articleLink && m.articleLink.length > 0 && (
        <div className="subhead-white" style={{ paddingTop: '0.3em', paddingBottom: '2em', textTransform: 'none' }}><a href={m.articleLink} >View article</a></div>
      )}
      <div className="subhead-white" style={{ textTransform: 'none', paddingTop: (!m.articleLink || !m.articleLink.length) ? '2em' : 0 }}>{m.discipline.split(',').map(d => `(${d.trim()})`).join(' ')}</div>
      {m.headline && m.headline.length > 0 && (
        <div className="subhead-white" style={{ textTransform: 'none', paddingBottom: '2em' }}>{m.headline}</div>
      )}
      {m.contributorRole && m.contributorRole.length > 0 && (
        <div className="subhead-white">
          {m.contributorRole}, <a href={m.contributorLink} >{m.contributorName}</a>
        </div>
      )}
      {m.contributorRole1 && m.contributorRole1.length > 0 && (
        <div className="subhead-white">
          {m.contributorRole1} — <a href={m.contributorLink1} >{m.contributorName1}</a>
        </div>
      )}
    </div>
  );
}

export default ProjectDescription;
